<div class="flex">
  <!-- Question -->
  <!-- <div>
    <p class="text-2xl text-gray-800">Qui a cogner le chauffeur de yango ?</p>
  </div> -->
  <div
    class="dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full border border-dashed bg-gray-100 border-gray-100"
  >
    <div class="px-[25px] py-[16px] group">
      <div class="w-40 relative">
        <p
          *ngIf="!editableTheme"
          class="text-gray-700 z-10 text-sm text-center cursor-pointer font-medium bg-gray-300 px-3 py-1 rounded-full"
        >
          {{ question?.theme.libelle }}
        </p>

        <nz-select
          *ngIf="editableTheme"
          ngClass="bg-red-500"
          [(ngModel)]="question.theme"
          class="border-gray-400/10 min-w-28"
          (ngModelChange)="onCategoryChange($event)"
        >
          <nz-option
            *ngFor="let category of categoryList"
            [nzLabel]="category.libelle"
            [nzValue]="category"
          ></nz-option>
        </nz-select>

        <span
          *ngIf="!editableTheme"
          (click)="toggleEditQuestionTheme()"
          class="text-gray-500 hover:bg-gray-200 opacity-0 group-hover:opacity-100 hover:text-gray-400 -z-10 group-hover:translate-x-[170px] group-hover:z-20 translate-x-0 transition-all cursor-pointer absolute text-sm text-center font-medium bg-gray-100 px-3 py-1 top-0 rounded-full"
        >
          Editer
        </span>

        <span
          *ngIf="editableTheme"
          (click)="toggleEditQuestionTheme()"
          class="text-gray-500 hover:bg-gray-200 opacity-0 group-hover:opacity-100 hover:text-gray-400 -z-10 group-hover:translate-x-[30px] group-hover:z-20 translate-x-0 transition-all cursor-pointer absolute text-sm text-center font-medium bg-gray-100 px-3 py-1 top-0 rounded-full"
        >
          Confirmer
        </span>
      </div>
    </div>
    <div
      class="py-[16px] px-[25px] flex justify-between items-center text-dark dark:text-white/[.87] font-medium text-[17px] border-regular dark:border-white/10 border-b"
    >
      <h4
        class="mb-0 text-lg font-medium max-w-[700px] text-dark dark:text-white/[.87]"
      >
        Question {{ questionIndex }}
      </h4>

      <!-- Difficulty Status -->
      <div class="flex gap-3 items-center">
        <nz-form-label>Niveau de question</nz-form-label>
        <nz-select
          class="w-full min-w-[200px]"
          [(ngModel)]="currentLevel"
          (ngModelChange)="changeQuestionLevel($event)"
          class="border-gray-400/10"
        >
          <nz-option
            *ngFor="let level of levelList"
            [nzLabel]="level.libelle"
            [nzValue]="level"
          ></nz-option>
          <!-- <nz-option [nzLabel]="'Binaire'" [nzValue]="'Binaire'"></nz-option> -->
        </nz-select>
        <!-- <span
          (click)="descreaseDifficulty()"
          nz-icon
          nzType="left"
          nzTheme="outline"
          class="text-xs cursor-pointer"
        ></span>

        <p class="text-sm text-white capitalize bg-blue-500 rounded-full p-2 mt-[2px]">
          {{ currentLevel?.libelle }}
        </p>

        <span
          (click)="increaseDifficulty()"
          nz-icon
          nzType="right"
          nzTheme="outline"
          class="text-xs cursor-pointer"
        ></span> -->
      </div>
    </div>

    <!-- Question Label -->
    <div
      class="group relative flex flex-col items-center gap-1 w-full p-6 bg-yellow-200"
    >
      <p
        *ngIf="!editableLabel"
        class="text-xl font-semibold text-center uppercase text-gray-700"
      >
        {{ question?.enonce }}
      </p>

      <input
        *ngIf="editableLabel"
        [(ngModel)]="question.enonce"
        nz-input
        placeholder="Renseigner l'enonce"
        nzSize="large"
      />

      <span
        *ngIf="!editableLabel"
        (click)="toggleEditQuestionLabel()"
        nz-icon
        
        class="text-center top-2 right-2 opacity-100 hover:text-gray-800 cursor-pointer text-gray-400"
        nzTheme="fill"
        >Modifier</span
      >

      <span
        *ngIf="editableLabel"
        nz-icon
       
        (click)="toggleEditQuestionLabel()"
        class="absolute text-center top-2 right-2 opacity-100 hover:text-gray-800 cursor-pointer text-gray-400"
        nzTheme="fill"
        >Enregistrer</span
      >
    </div>

    <div
      class="py-[16px] flex justify-between items-center px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px] border-regular dark:border-white/10 border-b"
    >
      <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87]">
        Proposition de réponses
      </h4>

      <div class="flex justify-center items-center gap-2">
        <nz-select
          [(ngModel)]="question.typeReponse"
          (ngModelChange)="toggleAnswerMode($event)"
          class="border-gray-400/10"
        >
          <nz-option [nzLabel]="'Multiple'" [nzValue]="'Multiple'"></nz-option>
          <nz-option [nzLabel]="'Binaire'" [nzValue]="'Binaire'"></nz-option>
        </nz-select>
      </div>
    </div>

    <!-- Propositions -->
    <div class="p-[25px] border-regular dark:border-white/10 border-b">
      <form nz-form class="grid grid-cols-2 gap-3">
        <nz-form-item
          class="flex items-center gap-2"
          *ngFor="let proposition of question?.proposition; let i = index"
        >
          <div
            (click)="selectCorrectAnswer(proposition, i)"
            class="p-3 rounded-full cursor-pointer"
          >
            <span
              nz-icon
              nzType="check-circle"
              nzTheme="outline"
              [ngClass]="
                proposition.isCorrect ? 'text-green-300' : 'text-gray-300'
              "
            >
            </span>
          </div>

          <nz-form-control nzLg="18" nzMd="15" nzXs="24">
            <input
              class="w-full rounded-4 border-normal border-1 text-[15px] dark:bg-white/10 dark:border-white/10 px-[20px] py-[12px] min-h-[50px] outline-none placeholder:text-[#A0A0A0] text-theme-gray dark:text-white/60"
              nz-input
              [(ngModel)]="proposition.title"
              name="answer{{ i + 1 }}"
              (click)="logggesLevelInfo()"
              type="text"
              id="answer{{ i + 1 }}"
              placeholder="Reponse {{ i + 1 }}"
            />
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>

      <!-- Time And Point -->
    <div class="flex flwex-wrap justify-around items-center">
      <span class="text-xs text-red-500">
        <nz-input-group nzAddOnAfter="secondes/s">
          <input type="number" nz-input [(ngModel)]="question.duree" />
        </nz-input-group>
      </span>
      <span class="text-xs text-red-500">
        <nz-input-group nzAddOnAfter="points/pts">
          <input
            type="number"
            nz-input
            [(ngModel)]="question.point"
          /> </nz-input-group
      ></span>
    </div>

    <!-- Good Answer -->
    <div class="p-[25px]"></div>
  </div>
</div>
